import { api } from './api';

// GET all users (table/minimal info)
export const getUsers = () => api.get('/admin/users');

// GET full user details
export const getUserDetails = (id: number) => api.get(`/admin/user/${id}`);

// UPDATE user (editable fields, incl. activate/suspend)
export const updateUser = (id: number, data: any) => api.patch(`/admin/user/${id}`, data);

// SUSPEND a user (generic PATCH)
export const suspendUser = (id: number) =>
    api.patch(`/admin/user/${id}`, { suspended: true });

// ACTIVATE a user (generic PATCH)
export const activateUser = (id: number) =>
    api.patch(`/admin/user/${id}`, { suspended: false });

// DELETE a user
export const deleteUser = (id: number) => api.delete(`/admin/user/${id}`);
